import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Button, ButtonProps, Typography } from '@hbf/dsl';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    '&:hover': {
      boxShadow: theme.shadows[2],
      backgroundColor: theme.palette.action.hover,
    },
    padding: theme.spacing(),
    width: '90px',
    height: '64px',
    [theme.breakpoints.up('sm')]: {
      width: '104px',
      height: '74px',
    },
    display: 'flex',
    flexDirection: 'column',
    placeContent: 'center',
    placeItems: 'center',
  },
  icon: {
    height: '24px',
    boxSizing: 'content-box',
    paddingBottom: theme.spacing(),
    color: theme.palette.secondary.main,
  },
  text: {
    width: '100%',
  },
}));

interface OwnProps {
  icon: React.ReactNode;
  text: string;
}

export type Props = ButtonProps & OwnProps;

export const VerticalButton: React.FC<Props> = ({
  icon,
  text,
  onClick,
  ...props
}) => {
  const { classes } = useStyles();

  return (
    <Button
      variant="contained"
      classes={{
        root: classes.root,
      }}
      onClick={onClick}
      {...props}
    >
      <div className={classes.icon}>{icon}</div>
      <Typography.HelperText
        textTransform="uppercase"
        overflow="ellipsis"
        className={classes.text}
      >
        {text}
      </Typography.HelperText>
    </Button>
  );
};
